import closeIcon from "../../assets/close-icon.png";
import { useLanguage, getReceiverManagementTranslation } from '../../hooks/useLanguage';

export const AddorEditReceiver = ({ handleSubmit, handleChange, isEditing, closeModal, formData, isLoading }) => {
    const [isSpanish] = useLanguage();
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-999">
            <div className="bg-white p-8 rounded shadow-lg min-w-[650px]">
                <div className='flex justify-between items-center mb-4'>
                    <h2 className='text-2xl font-bold'>{isEditing ? getReceiverManagementTranslation('editReceiver', isSpanish) : getReceiverManagementTranslation('addReceiver', isSpanish)}</h2>
                    <img className='h-6 w-6 cursor-pointer' src={closeIcon} onClick={closeModal} alt="Close" />
                </div>
                <form onSubmit={handleSubmit}>
                    <div className='flex flex-col'>
                        <div className="form-group flex-1">
                            <label htmlFor="name">{getReceiverManagementTranslation('receiverName', isSpanish)}</label>
                            <input
                                type="text"
                                name="nombre"
                                placeholder={getReceiverManagementTranslation('receiverName', isSpanish)}
                                className="form-input border-container-force"
                                value={formData.nombre}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group flex-1">
                            <label htmlFor="tax_id">{getReceiverManagementTranslation('receiverTaxId', isSpanish)}</label>
                            <input
                                type="text"
                                name="nif"
                                placeholder={getReceiverManagementTranslation('receiverTaxId', isSpanish)}
                                className="form-input border-container-force"
                                value={formData.nif}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group flex-1">
                            <label htmlFor="eori">{getReceiverManagementTranslation('receiverEori', isSpanish)}</label>
                            <input
                                type="text"
                                name="eori"
                                placeholder={getReceiverManagementTranslation('receiverEori', isSpanish)}
                                className="form-input border-container-force"
                                value={formData.eori}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group flex-1">
                            <label htmlFor="address">{getReceiverManagementTranslation('receiverAddress', isSpanish)}</label>
                            <input
                                type="text"
                                name="direccion"
                                placeholder={getReceiverManagementTranslation('receiverAddress', isSpanish)}
                                className="form-input border-container-force"
                                value={formData.direccion}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className='flex gap-4'>
                            <div className="form-group flex-1">
                                <label htmlFor="city">{getReceiverManagementTranslation('receiverCity', isSpanish)}</label>
                                <input
                                    type="text"
                                    name="localidad"
                                    placeholder={getReceiverManagementTranslation('receiverCity', isSpanish)}
                                    className="form-input border-container-force"
                                    value={formData.localidad}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group flex-1">
                                <label htmlFor="country">{getReceiverManagementTranslation('receiverCountry', isSpanish)}</label>
                                <input
                                    type="text"
                                    name="pais"
                                    placeholder={getReceiverManagementTranslation('receiverCountry', isSpanish)}
                                    className="form-input border-container-force"
                                    value={formData.pais}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                        <div className='flex mt-4'>
                            <button
                                type="submit"
                                className='border bg-default text-white rounded-full py-2 px-5 text-sm'
                                disabled={isLoading}
                            >
                                {isLoading ? getReceiverManagementTranslation('processing', isSpanish) : isEditing ? getReceiverManagementTranslation('updateReceiver', isSpanish) : getReceiverManagementTranslation('addReceiver', isSpanish)}
                            </button>
                            <button
                                type="button"
                                onClick={closeModal}
                                className='py-2 px-2 text-sm ml-2'
                                disabled={isLoading}
                            >
                                {getReceiverManagementTranslation('cancel', isSpanish)}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}